export default __webpack_public_path__ + "static/media/Video_5.e655ab6f.mp4";